import React from 'react';
import MaskedInput from 'react-text-mask';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS, DEFAULT_MASK, FUNNELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.LAST_NAME,
  IWHI: 'Family name',
  IMAN: 'Family name',
  ISHI: 'Family name'
};
export const LastName = props => {
  var _a;
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    required
  } = props;
  const mask = ((_a = props.mask) === null || _a === void 0 ? void 0 : _a.length) ? props.mask : DEFAULT_MASK;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional,
    required: required
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props,
      inputMode: "text",
      autoComplete: "family-name"
    })
  }));
};
LastName.defaultProps = {
  ...defaultFieldPropTypes,
  mask: []
};
const LastNameWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(LastName, {
  ...props
}));
export default LastNameWithFunnel;